import React, { useState } from "react";
import "../css/EscortVehicleList.css";
import ArrowDropUpIcon from "@mui/icons-material/ExpandLess";
import ArrowDropDownIcon from "@mui/icons-material/ExpandMore";
const EscortVehicleList = ({ vehicles }) => {
  return (
    <div className="escort-vehicle-list">
      <p>Vehicles</p>

      {vehicles?.length === 0 ? (
        <div className="no-escort-vehicle-message">No vehicle added</div>
      ) : (
        <div className="escort-vehicle-list-box">
          {vehicles?.map((vehicle, index) => (
            <VehicleItem key={index} vehicle={vehicle} index={index} />
          ))}
        </div>
      )}
    </div>
  );
};

const VehicleItem = ({ index, vehicle }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="escort-vehicle-item">
      <div className="escort-vehicle-header" onClick={toggleExpand}>
        <p className="escort-vehicle-name">{`Vehicle ${index + 1}`}</p>
        <span className="escort-vehicle-toggle-icon">
          {isExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </span>
      </div>

      {isExpanded && (
        <div className="escort-vehicle-details">
          <p>
            <strong>Model of The Vehicle:</strong> {vehicle.vehicleName}
          </p>
          <p>
            <strong>Registration Number:</strong> {vehicle.licensePlateNumber}
          </p>
          <p>
            <strong>Driver's Name:</strong> {vehicle.driverName}
          </p>
          <p>
            <strong>Vehicle Type:</strong> {vehicle.escortVehicleType}
          </p>
        </div>
      )}
    </div>
  );
};

export default EscortVehicleList;
